import './index.css'

const create = () => {
  const div = document.createElement('div')
  div.innerHTML = '<div class="kn-loading-mask"></div><div class="kn-loading"></div>'
  div.id = 'js-loading'
  div.style.display = 'none'
  document.body.appendChild(div)

  return {
    show() {
      document.getElementById('js-loading').style.display = 'block'
    },
    hide() {
      document.getElementById('js-loading').style.display = 'none'
    }
  }
}

const loading = create()
let num = 0

const load = {
  show() {
    num++
    loading.show()
  },
  hide() {
    num--
    if (num <= 0) {
      loading.hide()
    }
  }
}

export default load
